<template>
    <div class="list">
        <div class="list-wrapper"
            v-if="isLoaded && isHaveItem">
            <BurnItem
                v-for="(purchase, k) in purchases"
                :key="k"
                :index="k"
                :lbl="lbl"
                :purchase="purchase"
                :modalController="modalController"
                @clickPurchase="clickPurchase($event)" />
        </div>
        <EmptyList
            :lbl="lbl"
            v-if="isLoaded && !isHaveItem" />
    </div>
</template>
<script>
import Vue from 'vue';
import Account from '@/helper/AccountHelper.js';
import Locale from '@/helper/locale/locale.js';
import CacheHelper from "@/helper/CacheHelper.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
//service
import BurnItem from './BurnItem.vue';
import EmptyList from './EmptyList.vue';
import BzbsHistory from '@/core/History/service/BzbsHistory.js';

//core
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';
/**
 * property
 * @property {object} lbl Text for component.
 * @property {boolean} isLoading Loading status.
 * @property {object} listConfig Configuration for call api.
 * @property {object} filterConfig Filter configuration for call api.
 * @property {object} busEvent Bus event for parent component.
 * event
 * @event clickPurchase Click purchase item.
 * parent component bus event.
 * @event toggleLoading toggle loading in parent component.
 */
export default {
    name: "PurchaseList",
    components: {
        BurnItem,
        EmptyList,
    },
    props: {
        lbl: Object,
        isLoading: Boolean,
        listConfig: Object,
        filterConfig: Object,
        busEvent: Object,
        modalController: Object,
    },
    data: function () {
        return {
            purchase: null,
            purchases: [],
            isLoaded: false,
            isHaveItem: true,
            isForceRender: true,
            isSerialLoading: false,

            clickedIndex: 0,

            campaignType: Vue.CampaignType,
            // busModal: new Vue(),
            busSerialModal: new Vue(),
            tracking: new TrackingService(this)
        };
    },
    created: function () {
        this.getList();
        this.initialSeeMore();
        this.tracking.screenName('History_Point_Burn_Page');
        this.tracking.event('History_Point_Burn', 'Click_History_Point_Burn');
    },
    mounted: function () {
        //page busEvent.
        this.busEvent.$on('switchLang', this.switchLang);
        this.busEvent.$on('reinitList', this.setConfig);
        //modal busEvent
    },
    beforeDestroy: function() {
        window.onscroll = null;
    },
    methods: {
        //initial
        initialSeeMore: function () {
            window.onscroll = () => {
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            }
        },
        //event
        clickPurchase: function (index) {
            //check internet stuff.
            if (this.isSerialLoading) return;
            this.isSerialLoading = true;

            //var purchase = this.purchases[index];
            this.purchase = this.purchases[index];
            this.clickedIndex = index;

            if (!this.isShowSerialModal(this.purchase)){
                this.isSerialLoading = false;
                return;
            }

            var token = Account.getToken();
            if (this.purchase.type === this.campaignType.Interface) {
                let cacheHistory = new CacheHelper('session');
                cacheHistory.setCache('FromPage', '/')
                this.openInterfaceHistory(this.purchase);
                this.isSerialLoading = false;
                return;
            }

            this.modalController.loadingModal.show();
            BzbsHistory.apiRedeemUse(token, this.purchase.redeemKey).subscribe((result) => {
                this.modalController.loadingModal.hide();
                this.isSerialLoading = false;
                this.purchases[this.clickedIndex].updateAfterRedeem(result);

                var tmpPurchase = this.purchases[this.clickedIndex];

                if (this.isShowSerialModal(tmpPurchase)){
                    var serial = new SerialModel();
                    serial.setModelFromDataModel(tmpPurchase);

                    var cacheHistory = new CacheHelper('session');
                    cacheHistory.setCache('FromHistory', true);

                    this.modalController.serialModal
                        .setSerial(serial)
                        .setTag('detail')
                        .show();
                }else{
                    this.refreshList();
                }

            }, (err) => {
                this.isSerialLoading = false;
                console.log(err);
            });
        },
        openInterfaceHistory: function(purchase) {
            var sToken = Account.getTokenShuffle();
            var locale = Locale.getLocaleCode();
            var header = 'false';
            var theme = Vue.bzbsConfig.appname;
            var returnUrl = encodeURIComponent(window.location.href);

            // new generation landing interface
            if (purchase.privilegeMessageFormat == 'link') {
                var url = purchase.privilegeMessage;

                url = url.replace('<campaign_id>', purchase.id);
                url = url.replace('<token>', sToken);
                url = url.replace('<serial>', purchase.serial);
                url = url.replace('<locale>', Locale.getLocaleCode());

                url += '&return_url=' + returnUrl;

                window.location.replace(url);
                return;
            }

            // old default landing interface
            if (purchase.website &&
                purchase.website.indexOf('/Landing/starbucks') > 0) {
                    // var cache = new CacheHelper('session');
                    // cache.setCache('FromStarbuck', true);

                    window.location.href = purchase.website +
                        '&token=' + sToken +
                        '&locale=' + locale +
                        '&RedeemKey=' + purchase.redeemKey +
                        '&header=' + header +
                        '&theme=' + theme +
                        '&return_url=' + returnUrl; // ReturnUrl;
            }
        },
        //method
        getList: function () {
            this.showLoading();
            var token = Account.getToken();
            BzbsHistory.apiGetPurchase(token, this.listConfig, this.filterConfig).subscribe((purchases) => {
                this.hideLoading();

                this.listConfig.intSkip += this.listConfig.defaultTopAmount;
                //check is there are more campaign.
                if (purchases &&
                    purchases.length < this.listConfig.defaultTopAmount)
                    this.listConfig.isSeeMoreEnable = false;
                //reinitialize list if no skip.
                if (this.listConfig.intSkip == this.listConfig.defaultTopAmount)
                    this.purchases = [];

                for (var purchase of purchases) {
                    //TODO: Add GA Tracking.
                    this.purchases.push(purchase);
                }

                this.isLoaded = true;
                this.isHaveItem = this.purchases.length > 0
                    ? true
                    : false;

                this.hideLoading();
            }, (err) => {
                this.isLoaded = true;
                this.isHaveItem = false;
                this.hideLoading();
                console.log(err);
            });
        },
        loadMore: function () {
            if (!this.listConfig.isSeeMoreEnable) return;
            if (this.showLoading()) return;

            setTimeout(() => {
                this.getList();
            }, 500);
        },
        isShowSerialModal: function (purchase) {
            if (purchase.serial === 'XXXXXXX') return false;
            if (purchase.expireIn && purchase.expireIn <= 0) return false;

            if (purchase.type === this.campaignType.Interface) {
                if (purchase.pointType === "get")
                    return false;

                return true;
            }

            if (purchase.type === this.campaignType.Free ||
                purchase.type === this.campaignType.Deal ||
                purchase.type === this.campaignType.Buy) {
                if (purchase.delivered)  return false;
            }

            if (purchase.type === this.campaignType.Draw) return false;

            return true;
        },
        //utilities
        showLoading: function () {
            if (this.isLoading) return true;

            this.toggleLoading(true);
            return false;
        },
        hideLoading: function () {
            this.toggleLoading(false);
        },
        toggleLoading: function (isLoading) {
            this.$emit('toggleLoading', isLoading);
        },
        forceRender: function () {
            this.isForceRender = false;

            this.$nextTick().then( () => {
                this.isForceRender = true;
            });
        },
        refreshList: function () {
            var tmp = this.purchases;
            this.purchases = [];

            this.$nextTick().then( () => {
                this.purchases = tmp;
            });
        },
        //bus event
        switchLang: function () {
            this.purchases = [];
            this.getList();
        },

        serialExpired: function () {
            this.purchases[this.clickedIndex].setPurchaseExpired();
            this.refreshList();
        }
    }
};
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/base/baseDisplay.scss';

.list {
    width: 100%;

    .list-wrapper {
        @extend %display-flex;
        width: 100%;
    }
}
</style>
